import React from 'react';
import MaterialTable from 'material-table';
import TableIcons from '../utils/TableIcons';
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import RefreshIcon from "@material-ui/icons/Refresh";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {Backdrop, Box, Button, Chip, CircularProgress, Grid, Paper, Typography} from "@material-ui/core";
import useStyles from "../styles/styles";
import {Alert} from "@material-ui/lab";
import {navigate} from "@reach/router";
import AddIcon from "@material-ui/icons/Add";
import getEnvironment from "../utils/getEnvironment";

const Companies = () => {
    const classes = useStyles();
    const env = getEnvironment();
    const {loading, error, data, refetch} = useQuery(gql`
        query CompaniesPage {
            allCompanies {
                id
                billFileId
                billingName
                name
                advertiserId
                companyEmails {
                    id
                    companyId
                    email
                    primaryEmail
                }
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    if (loading) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    return (
        <>
            <Typography variant="h2">
                Companies List
            </Typography>
            <Paper className={classes.paper}>
                {!loading && error ? (
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                ) : null}
                <Grid container direction="row" justify="space-between" alignItems="center" style={{marginBottom: '15px'}}>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'right'}}>
                        {env === 'test' ? (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate('/info/companies/add')}
                                startIcon={<AddIcon/>}>
                                ADD COMPANY
                            </Button>
                        ) : null}
                    </Grid>
                </Grid>
                {!loading && data && data.allCompanies ? (
                    <MaterialTable
                        title=""
                        icons={TableIcons}
                        columns={[
                            {title: 'Id', field: "id", hidden: true},
                            {title: "Name", field: "name"},
                            {title: "Bill File Id", field: "billFileId"},
                            {title: "Billing Name", field: "billingName"},
                            {title: "Advertiser Id", field: "advertiserId"},
                            {
                                title: 'Emails', field: 'companyEmails',
                                render: rowData => {
                                    const { companyEmails } = rowData;
                                    if (!companyEmails.length) {
                                        return 'N/A';
                                    }

                                    return (
                                      <ul>
                                          {companyEmails.map(item => (
                                              <li key={item.id }>
                                                  <Typography variant="body2" style={{ paddingBottom: '5px' }}>
                                                      <Box display="flex" alignItems="center">
                                                          <strong>{item.email}</strong>
                                                          {item.primaryEmail ? (
                                                              <Chip
                                                                  style={{ margin: '0 10px' }}
                                                                  label={'Primary Email'}
                                                                  color="primary"
                                                              />
                                                          ) : null}
                                                      </Box>
                                                  </Typography>
                                              </li>
                                          ))}
                                      </ul>
                                    );
                                }
                            }
                        ]}
                        data={data.allCompanies.map(item => ({
                            id: item.id,
                            name: item.name || 'N/A',
                            billFileId: item.billFileId || 'N/A',
                            billingName: item.billingName || 'N/A',
                            advertiserId: item.advertiserId || 'N/A',
                            companyEmails: item.companyEmails || []
                        }))}
                        actions={
                            [
                                {
                                    icon: () => <RefreshIcon/>,
                                    tooltip: 'Refetch Data',
                                    isFreeAction: true,
                                    onClick: (event) => refetch()
                                },
                                {
                                    icon: () => <VisibilityIcon/>,
                                    tooltip: 'Edit Traffic Source',
                                    onClick: (event, rowData) => window.open(`/info/companies/${rowData.id}`)
                                },
                            ]}
                        options={{
                            pageSize: 100,
                            pageSizeOptions: [100, 200, 300],
                            headerStyle: {
                                minWidth: 'auto',
                            },
                            search: false,
                        }}
                    />
                ) : null}
            </Paper>
        </>
    );
};

export default Companies;
